// timeupdate fires every ~250 ms while playing; a larger jump is a seek, not
// time the viewer spent watching.
const MAX_TICK_SECONDS = 2;

export function createWatchCounter() {
	let lastTime: number | null = null;
	let total = 0;

	return {
		tick(currentTime: number) {
			if (lastTime !== null) {
				const delta = currentTime - lastTime;
				if (delta > 0 && delta <= MAX_TICK_SECONDS) {
					total += delta;
				}
			}
			lastTime = currentTime;
		},
		take() {
			const seconds = Math.floor(total);
			total = 0;
			lastTime = null;
			return seconds;
		},
	};
}
